import { render, staticRenderFns } from "./ChampionshipsOrder.vue?vue&type=template&id=73f780e7&"
import script from "./ChampionshipsOrder.vue?vue&type=script&lang=js&"
export * from "./ChampionshipsOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports